
/* BLAIRE SHOPS - CART DRAWER REFRESH FIX */

async function refreshDawnCartUI() {
  const cartUrl =
    (typeof routes !== 'undefined' && routes.cart_url) || '/cart';

  const [cartResponse, sectionResponse] = await Promise.all([
    fetch(`${cartUrl}.js`, {
      credentials: 'same-origin',
      cache: 'no-store'
    }),
    fetch(`${cartUrl}?sections=cart-drawer,cart-icon-bubble`, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
  ]);

  if (!cartResponse.ok || !sectionResponse.ok) {
    throw new Error('Unable to refresh cart');
  }

  const cartData = await cartResponse.json();
  const sections = await sectionResponse.json();
  const parser = new DOMParser();

  const drawer = document.querySelector('cart-drawer');

  if (drawer && sections['cart-drawer']) {
    const fresh = parser
      .parseFromString(sections['cart-drawer'], 'text/html')
      .querySelector('cart-drawer');

    const oldInner = drawer.querySelector('.drawer__inner');
    const newInner = fresh?.querySelector('.drawer__inner');

    if (!oldInner || !newInner) {
      throw new Error('Cart drawer content is missing');
    }

    oldInner.replaceWith(newInner);
    drawer.classList.toggle(
      'is-empty',
      cartData.item_count === 0
    );
  }

  const cartLink = document.getElementById('cart-icon-bubble');

  if (cartLink && sections['cart-icon-bubble']) {
    const freshBubble = parser
      .parseFromString(sections['cart-icon-bubble'], 'text/html')
      .querySelector('.shopify-section');

    if (freshBubble) {
      cartLink.innerHTML = freshBubble.innerHTML;
    }
  }

  if (
    typeof publish === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    await publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'external-refresh',
      cartData: cartData
    });
  }
}

function initBlaireCartFix() {
  const actions = window.Shopify?.actions;

  if (!actions?.openCart?.configure ||
      !actions?.updateCart?.configure) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');

      if (!drawer || typeof drawer.open !== 'function') {
        return defaultHandler();
      }

      try {
        await refreshDawnCartUI();
        drawer.open();
      } catch (error) {
        console.error('Blaire cart open error:', error);
        window.location.href = '/cart';
      }
    }
  });

  actions.updateCart.configure({
    eventTarget: () => document,

    async handler(defaultHandler) {
      const result = await defaultHandler();

      try {
        await refreshDawnCartUI();
      } catch (error) {
        console.error('Blaire cart refresh error:', error);
        window.location.reload();
      }

      return result;
    }
  });
}

if (window.Shopify?.actions) {
  initBlaireCartFix();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    initBlaireCartFix,
    { once: true }
  );
}
